var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCountryParam } from "@/hooks/useCountryParam";
import { SearchParamType } from "@/types/SearchParamType";
import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getUpdatedSearchParams } from "@/components/utils";
import Util from "../../util/Util";
import { SearchFormContext } from "./SearchFormContext";
function SearchForm(_a) {
    var children = _a.children;
    var _b = useSearchParams(), searchParams = _b[0], setSearchParams = _b[1];
    var countryParam = useCountryParam();
    var _c = useState(Util.normalize(searchParams.get(SearchParamType.WHAT) || "")), queryValue = _c[0], setQueryValue = _c[1];
    var _d = useState(Util.normalize(searchParams.get(SearchParamType.WHERE) || "")), locationValue = _d[0], setLocationValue = _d[1];
    var _e = useState(Util.normalize(countryParam)), countryValue = _e[0], setCountryValue = _e[1];
    var _f = useState(Util.normalizeBool(searchParams.get(SearchParamType.IS_REMOTE_ONLY) || "")), isRemoteOnlyValue = _f[0], setIsRemoteOnlyValue = _f[1];
    var _g = useState(Util.normalize(searchParams.get(SearchParamType.COMPANY) || "")), companyValue = _g[0], setCompanyValue = _g[1];
    var _h = useState(Util.normalize(searchParams.get(SearchParamType.OCCUPATION) || "")), occupationValue = _h[0], setOccupationValue = _h[1];
    var handleSubmit = function (e) {
        e.preventDefault();
        onSearchFormSubmit(queryValue, locationValue, countryValue, isRemoteOnlyValue, companyValue, occupationValue);
    };
    var value = useMemo(function () { return ({
        queryParamKey: SearchParamType.WHAT,
        queryValue: queryValue,
        setQueryValue: setQueryValue,
        locationParamKey: SearchParamType.WHERE,
        locationValue: locationValue,
        setLocationValue: setLocationValue,
        isRemoteOnlyParamKey: SearchParamType.IS_REMOTE_ONLY,
        isRemoteOnlyValue: isRemoteOnlyValue,
        setIsRemoteOnlyValue: setIsRemoteOnlyValue,
        countryParamKey: SearchParamType.COUNTRY,
        countryValue: countryValue,
        setCountryValue: setCountryValue,
        companyParamKey: SearchParamType.COMPANY,
        companyValue: companyValue,
        setCompanyValue: setCompanyValue,
        occupationParamKey: SearchParamType.OCCUPATION,
        occupationValue: occupationValue,
        setOccupationValue: setOccupationValue,
    }); }, [
        locationValue,
        queryValue,
        isRemoteOnlyValue,
        countryValue,
        companyValue,
        occupationValue,
    ]);
    var onSearchFormSubmit = function (queryValue, locationValue, countryValue, isRemoteOnlyValue, companyValue, occupationValue) {
        if (queryValue === void 0) { queryValue = undefined; }
        if (locationValue === void 0) { locationValue = undefined; }
        if (countryValue === void 0) { countryValue = undefined; }
        if (isRemoteOnlyValue === void 0) { isRemoteOnlyValue = undefined; }
        if (companyValue === void 0) { companyValue = undefined; }
        if (occupationValue === void 0) { occupationValue = undefined; }
        var updatedParams = getUpdatedSearchParams(searchParams, queryValue, locationValue, isRemoteOnlyValue, undefined, countryValue, companyValue, occupationValue);
        setSearchParams(updatedParams);
    };
    return (_jsx(SearchFormContext.Provider, __assign({ value: value }, { children: _jsx("form", __assign({ onSubmit: handleSubmit }, { children: children })) })));
}
export { SearchForm };
